const priceCache = new Map();

export async function fetchProductPrices(productXmlUrl) {
  if (priceCache.has(productXmlUrl)) {
    return priceCache.get(productXmlUrl);
  }

  const res = await fetch(productXmlUrl);
  const text = await res.text();
  const xml = new DOMParser().parseFromString(text, 'text/xml');
  const variants = xml.querySelectorAll('variant');

  const parsed = [];
  variants.forEach(v => {
    parsed.push({
      id:        v.querySelector('id')?.textContent,
      price:     parseFloat(v.querySelector('price')?.textContent) || 0,
      country:   v.querySelector('option1')?.textContent?.trim() || '',
      colorType: v.querySelector('option2')?.textContent?.trim() || '',
      montage:   v.querySelector('option3')?.textContent?.trim() || '',
    });
  });

  priceCache.set(productXmlUrl, parsed);
  return parsed;
}

/**
 *
 * @param {Array}  variants   - parsed variant list from fetchProductPrices
 * @param {object} opts
 * @param {string} opts.country      - 'Belgique' | 'France'
 * @param {string} opts.colorVariant - 'aluminium' | 'noir' | 'ral'
 * @param {boolean} opts.withMontage - true = Avec montage, false = Sans
 */
export function findVariantPrice(variants, { country, colorVariant, withMontage }) {
  return variants.find(v => {
    // Country: if XML has no country option, treat as universal match
    const matchCountry = !v.country || !country
      || v.country.toLowerCase().includes(country.toLowerCase());

    // Color = option2 text
    const ct = v.colorType.toLowerCase();
    let matchColor;
    if (colorVariant === 'noir') {
      matchColor = ct.includes('noir') || ct.includes('black') || ct.includes('9005');
    } else if (colorVariant === 'ral') {
      matchColor = ct.includes('couleur') || ct.includes('choix') || ct.includes('ral');
    } else {
      // 'aluminium' — standard/brut
      matchColor = !ct.includes('noir') && !ct.includes('black') && !ct.includes('9005')
                && !ct.includes('couleur') && !ct.includes('choix');
    }

    // montage =option3 text
    const mt = v.montage.toLowerCase();
    const matchMontage = withMontage
      ? mt.includes('montage') && !mt.includes('sans')
      : mt.includes('sans') || mt === '';

    return matchCountry && matchColor && matchMontage;
  });
}
